module.exports = __webpack_public_path__ + "static/media/SD_ALERT_20-cut.b663c693.mp3";